'use client';

import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import { darkTheme } from '@/shared/modules/styled-system';
import * as Styled from './skeleton-page-layout.styled';

/**
 * @useClient
 */
export const SkeletonPageLayout = React.memo(function SkeletonPageLayout({
  children
}: React.PropsWithChildren) {
  return <ThemeProvider theme={darkTheme}>
      <Styled.Container>
        <Styled.Header>
          <Styled.Logo>Logo</Styled.Logo>

          <Styled.Menu>
            {Array.from({
            length: 4
          }, (_, i) => <Styled.MenuItem key={i} />)}
          </Styled.Menu>

          <Styled.Avatar />
        </Styled.Header>

        <Styled.Content>
          {children ? children : <Styled.DefaultContent>
              {Array.from({
            length: 3
          }, (_, i) => <Styled.DefaultContentSection key={i} />)}
            </Styled.DefaultContent>}
        </Styled.Content>

        <Styled.Footer>
          <Styled.Info>
            <Styled.Title />
            <Styled.Slogan />
            <Styled.Copyright />
            <Styled.LanguageSwitcher />
          </Styled.Info>

          <Styled.Sitemap>
            {Array.from({
            length: 4
          }, (_, i) => <Styled.SitemapColumn key={i}>
                <Styled.SitemapTitle />
                {Array.from({
              length: 8
            }, (_, i) => <Styled.SitemapElement key={i} />)}
              </Styled.SitemapColumn>)}
          </Styled.Sitemap>
        </Styled.Footer>
      </Styled.Container>
    </ThemeProvider>;
});